import React, { useState } from "react";
import { Link } from "react-router-dom";
import {motion} from 'framer-motion';
import '../styles/navbar.css';
import NavImg from "../assests/navimg.svg";
import AddToCart from '../assests/addtocart.svg';
import ProFile from '../assests/profile.svg';

function Navbar()  {

  const [clicked, setClicked] = useState(false);

  const closeMobileMenu = () => {
    setClicked(false);
  };

  return (
    <nav className="navbar navbar-expand-lg fixed-top">
      <div className="container-fluid">
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ padding: "0px 5px" }}
        >
          <Link to="/" className="navbar-brand" onClick={closeMobileMenu}>
            <motion.img
              whileHover={{
                rotateZ: [0, -20, 20, -20, 20, -20, 20, 0],
                transition: { duration: 0.5 },
              }}
              src={NavImg}
              alt="iitm logo"
              className="logo"
            />
          </Link>
          <span className="fw-bold fs-4">Harini</span>
        </div>
        <div>
          <ul
            className={clicked ? "navbar-lists active" : "navbar-lists"}
            style={{ marginBottom: "0px" }}
          >
            <div className="mid-nav">
              <li>
                <Link className="active" to="/about" onClick={closeMobileMenu}>
                  Home
                </Link>
              </li>
              <li>
                <Link
                  className="active"
                  to="/solutions"
                  onClick={closeMobileMenu}
                >
                  Product
                </Link>
              </li>
              {/* <NavDropdown
              className="dropdow"
              title="Resources"
              id="basic-nav-dropdown"
              style={{ paddingBlock: "8px" }}
            >
              <NavDropdown.Item
                as={Link}
                to="/research"
                onClick={closeMobileMenu}
              >
                Research
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/learn" onClick={closeMobileMenu}>
                Learn
              </NavDropdown.Item>
              <NavDropdown.Item
                as={Link}
                to="/crypto"
                onClick={closeMobileMenu}
              >
                Crypto-Forensics
              </NavDropdown.Item>
            </NavDropdown> */}
              <li>
                <Link className="active" to="/team" onClick={closeMobileMenu}>
                  About
                </Link>
              </li>
              <li>
                <Link className="active" to="/blog" onClick={closeMobileMenu}>
                  Testimonial
                </Link>
              </li>
            </div>
          </ul>
        </div>
        <div className="la-nav">
          
            <li>
              <Link className="active" to="/careers" onClick={closeMobileMenu}>
                <img src={AddToCart} alt="" />
              </Link>
            </li>
            <li>
              <Link className="active" to="/summer" onClick={closeMobileMenu}>
                <img src={ProFile} alt="" />
              </Link>
            </li>
          
        </div>
        <div className="mobile">
          <i
            id="bar"
            className={clicked ? "fa fa-times" : "fa fa-bars"}
            onClick={() => setClicked(!clicked)}
          ></i>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
